export const translations = {
  it: {
    nav: {
      home: "Home",
      rooms: "Camere",
      experience: "Esperienza Torino",
      offers: "Offerte",
      services: "Servizi",
      about: "Chi siamo",
      contact: "Contatti",
    },
    cta: {
      book: "Prenota ora",
      explore: "Scopri le camere",
      discover: "Scopri",
      viewDetails: "Dettagli camera",
      viewAll: "Vedi tutte",
      viewOffer: "Vedi offerta",
      contact: "Contattaci",
      bookRoom: "Prenota questa camera",
    },
    hero: {
      overline: "Boutique Hotel · Torino",
      title: "Soggiorna a Torino.\nVivila con stile.",
      subtitle: "Un boutique hotel raffinato nel cuore di Torino, dove comfort, design e posizione si incontrano per offrirti un soggiorno senza compromessi.",
      micro: "Miglior tariffa garantita · Posizione centrale · Wi-Fi gratuito",
    },
    rooms: {
      overline: "Le nostre camere",
      title: "Spazi pensati per\nil tuo soggiorno.",
      subtitle: "Spazi pensati per il comfort, il relax e un soggiorno elegante nel cuore di Torino.",
      from: "Da",
      perNight: "a notte",
      size: "Dimensioni",
      guests: "Ospiti",
      bed: "Letto",
    },
    why: {
      overline: "Perché sceglierci",
      title: "Una nuova idea\ndi ospitalità.",
      items: [
        { title: "Posizione centrale", text: "A pochi passi dalla Mole Antonelliana, Piazza Vittorio Veneto e dai principali musei di Torino." },
        { title: "Design contemporaneo", text: "Interni curati da studi d'autore italiani, materiali pregiati, comfort misurato." },
        { title: "Servizio su misura", text: "Un concierge dedicato e uno staff attento ad ogni dettaglio del tuo soggiorno." },
        { title: "Miglior tariffa garantita", text: "Prenotando direttamente sul nostro sito ottieni sempre la tariffa migliore." },
      ],
    },
    turin: {
      overline: "Esperienza Torino",
      title: "Torino è parte\ndel tuo soggiorno.",
      subtitle: "Dalle piazze barocche ai musei contemporanei, dal vermouth ai ristoranti stellati. Il nostro concierge crea per te itinerari su misura.",
    },
    services: {
      overline: "Servizi & comfort",
      title: "Tutto ciò che serve,\nnulla di superfluo.",
      subtitle: "Una selezione curata di servizi pensati per un soggiorno senza compromessi.",
    },
    offers: {
      overline: "Offerte",
      title: "Soggiorni\nda vivere.",
      subtitle: "Pacchetti pensati per chi desidera un'esperienza davvero speciale a Torino.",
    },
    reviews: {
      overline: "Ospiti & recensioni",
      title: "Cosa dicono\ndi noi.",
    },
    contact: {
      overline: "Dove siamo",
      title: "Nel cuore\ndi Torino.",
      subtitle: "Facilmente raggiungibile da Porta Nuova, dall'aeroporto e dai principali punti di interesse.",
      phone: "Telefono",
      email: "Email",
      address: "Indirizzo",
      hours: "Reception",
      directions: "Come raggiungerci",
      howToReach: {
        title: "Come raggiungerci",
        train: { label: "Porta Nuova", sub: "Stazione centrale · 15 min a piedi" },
        car: { label: "In auto", sub: "Uscita tangenziale Torino Nord" },
        plane: { label: "Aeroporto Caselle", sub: "20 min in taxi · treno diretto" },
        parking: { label: "Parcheggio", sub: "Convenzionato nelle vicinanze" },
        openDirections: "Ottieni indicazioni",
        directionsPrompt: "Da dove parti?",
        directionsClose: "Chiudi",
        directionsChange: "Cambia",
        directionsResult: "Percorso verso l'hotel",
        directionsError: "Impossibile calcolare il percorso. Riprova.",
      },
    },
    about: {
      overline: "Chi siamo",
      title: "Un nuovo modo\ndi ospitare.",
      p1: "Nasciamo con un'idea precisa: trasformare un soggiorno a Torino in un'esperienza di design, comfort e cura per il dettaglio. Un boutique hotel dove ogni spazio racconta la raffinata ospitalità italiana contemporanea.",
      p2: "Lavoriamo con artigiani locali, studi di design e chef del territorio per creare un luogo che sia autentico, elegante e profondamente connesso con la città.",
    },
    booking: {
      title: "Prenota il tuo soggiorno",
      subtitle: "Inserisci i tuoi dati e ti risponderemo entro 2 ore con la miglior tariffa disponibile.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Ospiti",
      room: "Camera preferita",
      roomAny: "Qualsiasi camera (miglior tariffa)",
      message: "Richieste speciali",
      submit: "Invia richiesta",
      success: "Richiesta inviata! Ti contatteremo a breve.",
      error: "Qualcosa è andato storto. Riprova.",
      pickDate: "Seleziona data",
      nights: (n) => `${n} ${n === 1 ? "notte" : "notti"}`,
      estimated: "Stima",
      totalFrom: "Totale da",
      available: "Camera disponibile",
      response: "Risposta garantita in 2 ore",
      trust: {
        direct: "Prenotazione diretta",
        noCommission: "No commissioni OTA",
        bestRate: "Miglior tariffa garantita",
      },
    },
    footer: {
      tagline: "Un boutique hotel raffinato nel cuore di Torino.",
      pages: "Pagine",
      info: "Informazioni",
      follow: "Seguici",
      legal: "Note legali",
      privacy: "Privacy",
      rights: "Tutti i diritti riservati.",
    },
    stickyBook: "Prenota",
  },
  en: {
    nav: {
      home: "Home",
      rooms: "Rooms",
      experience: "Turin Experience",
      offers: "Offers",
      services: "Services",
      about: "About",
      contact: "Contact",
    },
    cta: {
      book: "Book now",
      explore: "Explore rooms",
      discover: "Discover",
      viewDetails: "Room details",
      viewAll: "View all",
      viewOffer: "View offer",
      contact: "Contact us",
      bookRoom: "Book this room",
    },
    hero: {
      overline: "Boutique Hotel · Turin",
      title: "Stay in Turin.\nExperience it in style.",
      subtitle: "A refined boutique hotel in the heart of Turin, where comfort, design, and location come together for a seamless stay.",
      micro: "Best rate guaranteed · Central location · Free Wi-Fi",
    },
    rooms: {
      overline: "Our rooms",
      title: "Spaces designed\nfor your stay.",
      subtitle: "Spaces designed for comfort, relaxation, and an elegant stay in the heart of Turin.",
      from: "From",
      perNight: "per night",
      size: "Size",
      guests: "Guests",
      bed: "Bed",
    },
    why: {
      overline: "Why us",
      title: "A new idea\nof hospitality.",
      items: [
        { title: "Central location", text: "Steps from the Mole Antonelliana, Piazza Vittorio Veneto and Turin's main museums." },
        { title: "Contemporary design", text: "Interiors curated by Italian studios, fine materials, measured comfort." },
        { title: "Tailored service", text: "A dedicated concierge and attentive staff for every detail of your stay." },
        { title: "Best rate guaranteed", text: "By booking directly on our site you always get the best rate available." },
      ],
    },
    turin: {
      overline: "Turin Experience",
      title: "Turin is part\nof your stay.",
      subtitle: "From Baroque squares to contemporary museums, from vermouth to starred restaurants. Our concierge crafts tailored itineraries for you.",
    },
    services: {
      overline: "Services & comfort",
      title: "Everything you need,\nnothing unnecessary.",
      subtitle: "A curated selection of services designed for a stay without compromise.",
    },
    offers: {
      overline: "Offers",
      title: "Stays to be\nlived.",
      subtitle: "Packages crafted for those seeking a truly special experience in Turin.",
    },
    reviews: {
      overline: "Guests & reviews",
      title: "What guests\nsay about us.",
    },
    contact: {
      overline: "Where we are",
      title: "In the heart\nof Turin.",
      subtitle: "Easily reached from Porta Nuova station, the airport and the main points of interest.",
      phone: "Phone",
      email: "Email",
      address: "Address",
      hours: "Reception",
      directions: "Get directions",
      howToReach: {
        title: "How to reach us",
        train: { label: "Porta Nuova", sub: "Central station · 15 min on foot" },
        car: { label: "By car", sub: "Torino Nord ring road exit" },
        plane: { label: "Caselle Airport", sub: "20 min by taxi · direct train" },
        parking: { label: "Parking", sub: "Partnership nearby" },
        openDirections: "Get directions",
        directionsPrompt: "Where are you starting from?",
        directionsClose: "Close",
        directionsChange: "Change",
        directionsResult: "Route to the hotel",
        directionsError: "Could not calculate the route. Please try again.",
      },
    },
    about: {
      overline: "About",
      title: "A new way\nto host.",
      p1: "Born with a clear idea: turning a stay in Turin into an experience of design, comfort and attention to detail. A boutique hotel where every space tells refined contemporary Italian hospitality.",
      p2: "We work with local artisans, design studios and regional chefs to create a place that is authentic, elegant and deeply connected to the city.",
    },
    booking: {
      title: "Book your stay",
      subtitle: "Enter your details and we'll get back to you within 2 hours with the best available rate.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Guests",
      room: "Preferred room",
      roomAny: "Any room (best rate)",
      message: "Special requests",
      submit: "Send request",
      success: "Request sent! We'll contact you shortly.",
      error: "Something went wrong. Please try again.",
      pickDate: "Pick date",
      nights: (n) => `${n} ${n === 1 ? "night" : "nights"}`,
      estimated: "Estimate",
      totalFrom: "Total from",
      available: "Room available",
      response: "Reply within 2 hours",
      trust: {
        direct: "Direct booking",
        noCommission: "No OTA fees",
        bestRate: "Best rate guaranteed",
      },
    },
    footer: {
      tagline: "A refined boutique hotel in the heart of Turin.",
      pages: "Pages",
      info: "Information",
      follow: "Follow us",
      legal: "Legal",
      privacy: "Privacy",
      rights: "All rights reserved.",
    },
    stickyBook: "Book",
  },
};

export const routes = {
  it: {
    home: "/it",
    rooms: "/it/camere",
    room: (slug) => `/it/camere/${slug}`,
    experience: "/it/esperienza-torino",
    offers: "/it/offerte",
    services: "/it/servizi",
    about: "/it/chi-siamo",
    contact: "/it/contatti",
  },
  en: {
    home: "/en",
    rooms: "/en/rooms",
    room: (slug) => `/en/rooms/${slug}`,
    experience: "/en/turin-experience",
    offers: "/en/offers",
    services: "/en/services",
    about: "/en/about",
    contact: "/en/contact",
  },
};
